import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';

export const getBooleanLabel = (
	value: string | boolean | null | undefined,
	tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>
): string => {
	const normalised = typeof value === 'boolean' ? String(value) : value;
	if (normalised === 'true') {
		return tCommonUi('boolean.true');
	}
	if (normalised === 'false') {
		return tCommonUi('boolean.false');
	}
	return LONG_DASH;
};
